import React from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Modal, Tooltip } from "antd";
import { InfoCircleOutlined, CopyOutlined } from "@ant-design/icons";
import { ApiClientData } from "./types/apiClients";

type NewApiClientProps = {
  addedNewClient: {
    isActive: boolean;
    data: ApiClientData | null;
  };
  defaultNewClient: {
    isActive: boolean;
    data: ApiClientData | null;
  };
  setAddedNewClient: (state: {
    isActive: boolean;
    data: ApiClientData | null;
  }) => void;
  onClose?: () => void;
};

const NewApiClientConfirmation = ({
  addedNewClient,
  defaultNewClient,
  setAddedNewClient,
  onClose,
}: NewApiClientProps) => {

  const handleModalClose = () => {
    setAddedNewClient(defaultNewClient);
    onClose?.();
  };

  return (
    <Modal
      title={`Api Client Added (${addedNewClient?.data?.name})`}
      open={addedNewClient.isActive}
      cancelText={"Close"}
      okButtonProps={{ style: { display: "none" } }}
      cancelButtonProps={{ type: "primary", danger: true }}
      onCancel={handleModalClose}
    >
      <p>
        Your Api Client has been added to Mercury, shown below are your client
        ID and secret that can be used to access Mercury.
      </p>
      <br/>
      <p>
        <InfoCircleOutlined
          style={{ color: "var(--red)", marginRight: "5px" }}
        />
        Please store these in a safe location, the client secret will not be
        visible again once you close this message.
      </p>
      <br/>
      <p>
        <b>Client ID: </b>
        {addedNewClient?.data?.clientId}{" "}
        <Tooltip
          title="Copy Client ID to Clipboard"
          color={"var(--tertiary-color)"}
          placement={"right"}
        >
          <CopyToClipboard text={addedNewClient?.data?.clientId || ""}>
            <CopyOutlined
              style={{
                color: "var(--tertiary-color)",
                padding: "5px 5px 0",
              }}
            />
          </CopyToClipboard>
        </Tooltip>
      </p>
      <>
        <b>Client Secret: </b>
        {addedNewClient?.data?.clientSecret}{" "}
        <Tooltip
          title="Copy Client Secret to Clipboard"
          color={"var(--tertiary-color)"}
          placement={"right"}
        >
          <CopyToClipboard text={addedNewClient?.data?.clientSecret || ""}>
            <CopyOutlined
              style={{
                color: "var(--tertiary-color)",
                padding: "5px 5px 0",
              }}
            />
          </CopyToClipboard>
        </Tooltip>
      </>
    </Modal>
  );
};

export default NewApiClientConfirmation;
